<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created(){
    let style=localStorage.getItem("style")
    if(style){
      document.getElementById("style").setAttribute("href",style);
    }
  }

}
</script>